import { Divider, Text } from '@chakra-ui/react'
import React from 'react'

const SubTitle = ({ title, titleIcon }) => {
    return (
        <>
            <Text p="2" display="flex" justifyContent="start" alignItems="center" color="gray.500" fontSize="lg" >
                {titleIcon}
                <span style={{ marginLeft: "3px" }}>{title}</span>
            </Text>
            <Divider />
        </>
    )
}

export default SubTitle